'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ResponsiveDropDown = require('./ResponsiveDropDown');

var _ResponsiveDropDown2 = _interopRequireDefault(_ResponsiveDropDown);

require('./LabeledDropdown.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabeledDropdown = function LabeledDropdown(props) {
  var label = props.label,
      className = props.className,
      rest = (0, _objectWithoutProperties3.default)(props, ['label', 'className']);


  return _react2.default.createElement(
    'div',
    { className: 'labeled-dropdown ' + className },
    _react2.default.createElement(
      'span',
      { className: 'labeled-dropdown__label' },
      label,
      ' : '
    ),
    _react2.default.createElement(_ResponsiveDropDown2.default, (0, _extends3.default)({
      theme: 'borderless'
    }, rest))
  );
};

LabeledDropdown.defaultProps = {
  preIcon: '',
  className: ''
};

exports.default = LabeledDropdown;